<template>
    <div class="box loading">
        <div class="col-3">
            <div class="loading-row">
                <div class="dot-elastic"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default { 
        name: "loadingDotsDark",
        props: ['theme']
    }
</script>


<style scoped>
.box {
    height: 100%;
}
.col-3 {
    height: 100%;
}
.loading-row {
    height: 100%;
}
.loading:before {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 5px;
    content: attr(data-title);
    font-size: .75rem;
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    color: white;
    background-color: rgb(255, 25, 100);
    border-radius: .25rem 0 .25rem 0;
}

.loading-row {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 0rem 0;
    margin: 0 -5%;
    overflow: hidden;
}

.dot-elastic {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #1B608C;
    color: #1B608C;
    animation: dotElastic 1s infinite linear;
}

.dot-elastic::before, .dot-elastic::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
}

.dot-elastic::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #1B608C;
    color: #1B608C;
    animation: dotElasticBefore 1s infinite linear;
}

.dot-elastic::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #1B608C;
    color: #1B608C;
    animation: dotElasticAfter 1s infinite linear;
}

@keyframes dotElasticBefore {
    0% {
        transform: scale(1, 1);
    }
    25% {
        transform: scale(1, 1.5);
    }
    50% {
        transform: scale(1, 0.67);
    }
    75% {
        transform: scale(1, 1);
    }
    100% {
        transform: scale(1, 1);
    }
}

@keyframes dotElastic {
    0% {
        transform: scale(1, 1);
    }
    25% {
        transform: scale(1, 1);
    }
    50% {
        transform: scale(1, 1.5);
    }
    75% {
        transform: scale(1, 1);
    }
    100% {
        transform: scale(1, 1);
    }
}

@keyframes dotElasticAfter {
    0% {
        transform: scale(1, 1);
    }
    25% {
        transform: scale(1, 1);
    }
    50% {
        transform: scale(1, 0.67);
    }
    75% {
        transform: scale(1, 1.5);
    }
    100% {
        transform: scale(1, 1);
    }
}
</style>